export const getFileExtension = (filename: string): string => {
  const parts = filename.split('.')
  if (parts.length > 1) {
    const ext = parts[parts.length - 1].toUpperCase()
    // Map common extensions to shorter versions
    switch (ext) {
      case 'XLSX':
      case 'XLS':
        return 'XLS'
      case 'DOCX':
      case 'DOC':
        return 'DOC'
      case 'JPEG':
        return 'JPG'
      case 'TIFF':
        return 'TIF'
      default:
        return ext.substring(0, 3) // Limit to 3 characters
    }
  }
  return 'FILE'
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}

export const formatFileDate = (dateString: string): string => {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))

  if (diffHours < 1) {
    return 'Just now'
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`
  } else if (diffDays === 1) {
    return 'Yesterday'
  } else if (diffDays < 7) {
    return `${diffDays} days ago`
  } else if (diffDays < 14) {
    return 'Last week'
  } else if (diffDays < 30) {
    return `${Math.floor(diffDays / 7)} weeks ago`
  } else {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    })
  }
}

export type FileCategory =
  | 'PDF Documents'
  | 'Spreadsheets'
  | 'CAD Files'
  | 'Images'
  | 'Documents'
  | 'Other'
  | 'all'

export const isPreviewableFile = (filename?: string): boolean => {
  if (!filename) return false
  const ext = filename.split('.').pop()?.toLowerCase()
  if (!ext) return false
  const previewableExtensions = [
    'pdf',
    'png',
    'jpg',
    'jpeg',
    'gif',
    'webp',
    'svg',
    'bmp',
  ]
  return previewableExtensions.includes(ext)
}

export const getFileCategory = (mimeType?: string): FileCategory => {
  if (!mimeType) return 'Other'

  if (mimeType.includes('pdf')) return 'PDF Documents'
  if (mimeType.includes('spreadsheet') || mimeType.includes('excel'))
    return 'Spreadsheets'
  if (mimeType.includes('dwg') || mimeType.includes('dxf')) return 'CAD Files'
  if (mimeType.startsWith('image/')) return 'Images'
  if (mimeType.includes('document') || mimeType.includes('msword'))
    return 'Documents'

  return 'Other'
}
